import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button } from 'react-bootstrap';
import { fetchProjects, fetchProjectByRole, getProjectsJSON } from '../../store/actions/projects/projectsActions';
import { getProjCumulativeReport, 
  resetProjectCumulative, 
  refreshReports, 
  generateExportData } from '../../store/actions/reports/reportsActions';
import { TEAM_LEADER } from '../../store/actions/users/usersActions';


import Select from 'react-select';

import { drawTable } from '../../common/Utilities';
import PageTitle from '../../common/PageTitle';
import ExportReport from './ExportReport';

import '../../css/reports.css';

class ProjectTimesheetCumulative extends Component {

  constructor(props) {
    super(props);

    this.showTable = true;
    this.projectId = '';
  }

  componentDidMount() {
    const userId = Cache.getItem('userId');
    const filters = {
      project_manager: userId, 
      is_disabled: 0
    }

    this.props.fetchProjects(filters);
    this.props.fetchProjectByRole();
  }

  componentWillUnmount() {
    this.props.refreshReports();

    Cache.removeItem('exportHeaders');
    Cache.removeItem('exportData');
    Cache.removeItem('keyValues');
  }

  displayProjectDropDown = () => {

    let projectsJSON = this.props.getProjectsJSON({is_disabled: 0});
    if (this.roleId === TEAM_LEADER && projectsJSON.length) {
      projectsJSON.unshift({
        key: 0,
        value: 0,
        label: '--SELECT ALL PROJECTS--'
      });
    }

    const selectClass = 'projectSelect';

    return (
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          size="sm"
          onChange={(selectedOption) => {
            this.projectId = selectedOption.value;
          }}
          options={projectsJSON}
        />
      </Col>
    )
  }

  displayGenerateButton = () => {
    return (
      <Button 
        className="float-right"
        id={this.buttonId}
        onClick={()=>{ 
          this.props.fetchProjects({
            id: this.projectId,
            is_disabled: 0
          }, () => {
            this.props.resetProjectCumulative();
          });
          this.showTable = true;
          
        }}
      >
        Generate Report
      </Button>
    )
  }

  displayProjCumulative = (projectIds) => {
    let tableData = {}
    tableData.headerClass = "align-center";
    tableData.headers = [
      'Project Name',
      'Task',
      'Original Estimate',
      'Employee', 
      'Date', 
      'Hours', 
      'Status'
    ];

    let keyValues = [
      'project', 
      'task', 
      'estimate', 
      'employee', 
      'entryDate', 
      'hours',
      'status'
    ];

    let exportData = [];

    tableData.body = [];
    let items = [];
    let totalHours = 0;

    if (projectIds.length) {
      this.props.getProjCumulativeReport(projectIds);

      items = this.props.reports.projectCumulative;

      if (items) {
        if (items.length) {

          
          items.forEach(item => {
            let projectName = '';
            let taskName = '';
            let estimate = 0;
            let employeeName = 0;
            let entryDate = '';
            let hours = 0;
            let status = '';
  
            let row = [];
            let exportRow = {};

            if (typeof(item.project_details) !== "undefined") {
              const project = item.project_details;
              if (project) {
                projectName = project.project_name
              }
            }
  
            if (typeof(item.task_details) !== "undefined") {
              const task = item.task_details;
              if (task) {
                taskName = task.name;
              }
            }
  
            if (typeof(item.user_details) != "undefined") {
              const user = item.user_details;
              if (user) {
                employeeName = user.first_name + " " + user.last_name;
              }
            }

            estimate = item.hours ? item.hours : 0;
            status = item.status;
            entryDate = item.time_entry_date;
            hours = item.duration;

            totalHours += hours;

            row.push(projectName);
            row.push(taskName);
            row.push(estimate);
            row.push(employeeName);
            row.push(entryDate);
            row.push(hours);
            row.push(status);

            Object.assign(exportRow, {[keyValues[0]]: projectName});
            Object.assign(exportRow, {[keyValues[1]]: taskName});
            Object.assign(exportRow, {[keyValues[2]]: estimate});
            Object.assign(exportRow, {[keyValues[3]]: employeeName});
            Object.assign(exportRow, {[keyValues[4]]: entryDate});
            Object.assign(exportRow, {[keyValues[5]]: hours});
            Object.assign(exportRow, {[keyValues[6]]: status});

            tableData.body.push(row);
            exportData.push(exportRow);
            
          })

          exportData.push({
            [keyValues[0]]: '', 
            [keyValues[1]]: '', 
            [keyValues[2]]: '', 
            [keyValues[3]]: '', 
            [keyValues[4]]: 'Total Hours:', 
            [keyValues[5]]: totalHours,
            [keyValues[6]]: '',  
          })
        }
        else {
          tableData.body = null;
        }
      }
    }

    this.exportData = exportData;
    this.exportHeaders = tableData.headers;

    let totalHoursRow = (
      <tr>
        <td colSpan={4}></td>
        <td className='align-right'><b>Total Hours: </b></td>
        <td className='align-center'><b>{ totalHours }</b></td>
        <td></td>
      </tr>
    )

    return drawTable(tableData, this.showTable, totalHoursRow);
  }

  generateExportButton = () => {
    if (!this.showTable || !this.exportData || !this.exportHeaders) {
      return '';
    }

    const data = generateExportData(this.exportHeaders, this.exportData);

    return (
      <ExportReport fileName="project_timesheet_cumulative" data={data} />
    )
  }

  render() {
    const projects = this.props.projects.projects
    const arrProjectIds = projects 
                    && projects.length 
                    && projects.filter(project => project.is_disabled === 0).map(project => project.id);


    return (
      <React.Fragment>
        <PageTitle pageName="Project Timesheet Cumulative" />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={9} sm={9} md={9} lg={9} xl={9}>
                { this.displayProjectDropDown() }
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3} >
                { this.displayGenerateButton() }
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            { this.displayProjCumulative(arrProjectIds) }
          </Col>
        </Row>
        <Row>
          <Col>
            { this.generateExportButton() }
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  reports: state.reports
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    fetchProjectByRole: () => dispatch(fetchProjectByRole()),
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    getProjCumulativeReport: (...args) => dispatch(getProjCumulativeReport(...args)),
    resetProjectCumulative: () => dispatch(resetProjectCumulative()),
    refreshReports: () => dispatch(refreshReports())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectTimesheetCumulative))